/**
 * PATH: apps/qa/src/lib/inspection/building-classes.ts
 * PURPOSE: Australian NCC Building Class definitions
 */

import { Home, Building, Building2, Landmark, Shield } from 'lucide-react'
import type { BuildingClassInfo } from './types'

export const BUILDING_CLASS_INFO: Record<string, BuildingClassInfo> = {
  'Class 1a': {
    name: 'Class 1a',
    description: 'Single dwelling - a detached house, or one of a group of attached dwellings separated by fire-resisting walls',
    examples: 'Houses, townhouses, row houses, terrace houses',
    icon: Home,
  },
  'Class 1b': {
    name: 'Class 1b',
    description: 'Small boarding house, guest house, hostel or similar with floor area ≤ 300m² and ≤ 12 persons',
    examples: 'Small B&Bs, guest houses, backpacker hostels',
    icon: Home,
  },
  'Class 2': {
    name: 'Class 2',
    description: 'Multiple dwelling building containing 2 or more sole-occupancy units',
    examples: 'Apartments, flats, units',
    icon: Building,
  },
  'Class 3': {
    name: 'Class 3',
    description: 'Residential building providing long-term or transient accommodation for people',
    examples: 'Hotels, motels, boarding houses > 12 persons, backpacker hostels, residential care buildings',
    icon: Building,
  },
  'Class 4': {
    name: 'Class 4',
    description: 'Dwelling in a building of another class (caretaker\'s residence)',
    examples: 'Caretaker\'s flat above a shop, manager\'s unit in a warehouse',
    icon: Home,
  },
  'Class 5': {
    name: 'Class 5',
    description: 'Office building used for professional or commercial purposes',
    examples: 'Offices, professional suites, government buildings',
    icon: Building2,
  },
  'Class 6': {
    name: 'Class 6',
    description: 'Shop or retail premises for direct sale of goods or services',
    examples: 'Shops, restaurants, cafes, showrooms, shopping centres',
    icon: Building2,
  },
  'Class 7a': {
    name: 'Class 7a',
    description: 'Car park building',
    examples: 'Multi-storey car parks, parking stations',
    icon: Building2,
  },
  'Class 7b': {
    name: 'Class 7b',
    description: 'Storage or display of goods for wholesale/distribution',
    examples: 'Warehouses, storage facilities, display halls',
    icon: Building2,
  },
  'Class 8': {
    name: 'Class 8',
    description: 'Laboratory or building for production, assembly, alteration, repair, packaging, finishing or cleaning of goods',
    examples: 'Factories, workshops, laboratories, production facilities',
    icon: Building2,
  },
  'Class 9a': {
    name: 'Class 9a',
    description: 'Health-care building providing medical treatment or care',
    examples: 'Hospitals, day surgery centres, nursing homes, aged care',
    icon: Building,
  },
  'Class 9b': {
    name: 'Class 9b',
    description: 'Assembly building where people gather for civic, cultural, educational, recreational, or similar purposes',
    examples: 'Schools, universities, churches, community halls, theatres, stadiums',
    icon: Landmark,
  },
  'Class 9c': {
    name: 'Class 9c',
    description: 'Aged care building for residential accommodation of aged persons with varying levels of care',
    examples: 'Aged care facilities, residential aged care',
    icon: Building,
  },
  'Class 10a': {
    name: 'Class 10a',
    description: 'Non-habitable building - private garage, carport, shed, or similar',
    examples: 'Garages, carports, sheds, farm buildings',
    icon: Home,
  },
  'Class 10b': {
    name: 'Class 10b',
    description: 'Non-habitable structure - fence, mast, antenna, retaining wall, swimming pool, etc.',
    examples: 'Fences, retaining walls, pools, tennis courts, signs',
    icon: Landmark,
  },
  'Class 10c': {
    name: 'Class 10c',
    description: 'Private bushfire shelter associated with a Class 1a building',
    examples: 'Domestic bushfire bunkers/shelters',
    icon: Shield,
  },
}
